import React from 'react';

const Navbar = () => (
  <nav>
    <h1>Algorithm Visualizer</h1>
  </nav>
);

export default Navbar;
